export default __webpack_public_path__ + "static/media/streetwear_next.8bb308e1.png";